import { Stack } from '@ace-clublabs/shared-component-library';
import { AddMemberCTA } from './CTAs/AddMemberCTA';
import { UpgradeBenefitsCTA } from './CTAs/UpgradeBenefitsCTA';
import { MembershipCardCTA } from './CTAs/MembershipCardCTA';
import { useEffect, useState } from 'react';
import { useGlobalState } from '../../state/state';

export const MembershipCTAs = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  const [isMobileApp] = useGlobalState('isMobileApp');

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 769);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <Stack
        id="membership-ctas"
        direction={'row'}
        gap={'8px'}
        flexWrap={isMobile ? 'nowrap' : 'wrap'}
        sx={{
          maxWidth: '475px',
          rowGap: '16px',
          marginBottom: '3rem',
          overflowX: isMobile ? 'scroll' : undefined,
          '@media (max-width: 768px)': {
            margin: '0 -1rem 2.5rem -1rem',
            padding: '0 0.9rem',
            // hide scrollbar for Chrome, Safari, Edge, Opera
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          },
        }}
      >
        <UpgradeBenefitsCTA />
        <AddMemberCTA />
        <MembershipCardCTA visible={!isMobileApp} />
      </Stack>
    </>
  );
};
